import { useState } from 'react';
import clsx from 'clsx';
import { Link, Outlet, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Button } from 'primereact/button';
import logo from '../../assets/logo.svg';
import { selectIsSubscriberAuthenticated } from '../../slices/subscriberAuthSlice';
import getSubdomain from '../../utils/getSubdomain';
import SubscriberMenu from '../SubscriberMenu/SubscriberMenu';
import styles from './PublicLayout.module.css';

export default function PublicLayout() {
  const currentYear = new Date().getFullYear();
  const { organizationSlug: slugFromPath } = useParams();
  const subdomainSlug = getSubdomain();
  const organizationSlug = slugFromPath ?? subdomainSlug;
  const loginPath = '/subscriber/login';
  const subscriptionsPath = subdomainSlug
    ? '/subscriptions'
    : `/o/${organizationSlug}/subscriptions`;
  const myGroupsPath = subdomainSlug ? '/my-groups' : `/o/${organizationSlug}/my-groups`;
  const settingsPath = subdomainSlug ? '/settings' : `/o/${organizationSlug}/settings`;

  const isAuthed = useSelector(selectIsSubscriberAuthenticated);
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className={styles.layout}>
      <header className={styles.header}>
        {isAuthed ? (
          <Link to={myGroupsPath} className={styles.logoLink}>
            <img src={logo} alt="PulseLoop" className={styles.logo} />
          </Link>
        ) : (
          <img src={logo} alt="PulseLoop" className={styles.logo} />
        )}
        {isAuthed ? (
          <Button
            icon="pi pi-bars"
            text
            className={styles.menuBtn}
            onClick={() => setMenuOpen(true)}
            aria-label="Open menu"
          />
        ) : (
          <Link to={loginPath} className={styles.loginLink}>
            <i className="pi pi-user" />
            Log in
          </Link>
        )}
      </header>

      <main className={clsx('container', styles.main)}>
        <Outlet />
      </main>

      <footer className={styles.footer}>
        © {currentYear} All Rights Reserved, 1FIIT Technology
      </footer>

      {isAuthed && (
        <SubscriberMenu
          visible={menuOpen}
          onHide={() => setMenuOpen(false)}
          loginPath={loginPath}
          myGroupsPath={myGroupsPath}
          subscriptionsPath={subscriptionsPath}
          settingsPath={settingsPath}
        />
      )}
    </div>
  );
}
